import React from 'react'

import { makeStyles, Table, TableBody, TableCell, TablePagination, TableRow } from '@material-ui/core'

import EnhancedTableHead from './tableHead'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%'
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2)
  },
  tableWrapper: {
    overflowX: 'auto'
  }
}))

const EnhancedTable = props => {
  const classes = useStyles()
  const [pagina, setPagina] = React.useState(0)
  const [filasPorPagina] = React.useState(5)

  const handleChangePage = (_, newPage) => {
    setPagina(newPage)
  }

  const filasNulas = filasPorPagina - Math.min(filasPorPagina, props.filas.length - pagina * filasPorPagina)
  return (
    <>
      <div className={classes.tableWrapper}>
        <Table aria-labelledby='tableTitle' size='small' className='zr-table'>
          <EnhancedTableHead headRows={props.headRows} />
          <TableBody>
            {props.filas.slice(pagina * filasPorPagina, pagina * filasPorPagina + filasPorPagina).map(props.rowTemplate)}
            {filasNulas > 0 && (
              <TableRow style={{ height: 28 * filasNulas }}>
                <TableCell colSpan={props.headRows.length} />
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
      <TablePagination
        rowsPerPageOptions={[]}
        component='div'
        count={props.filas.length}
        rowsPerPage={filasPorPagina}
        page={pagina}
        backIconButtonProps={{
          'aria-label': 'Previous Page'
        }}
        nextIconButtonProps={{
          'aria-label': 'Next Page'
        }}
        onChangePage={handleChangePage}
        labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count <= 500 ? count : `más de ${to}`}`}
      />
    </>
  )
}

export default EnhancedTable
